import React from 'react';

import { GalleryIcon } from '@travel/ui';
import { GalleryMedia } from '@travel/ui/components/Gallery';
import { cx } from '@travel/utils';

import Media from 'components/Media';

import styles from './roomPlanGalleryCover.module.scss';

type Props = {
  handleClickGalleryIcon(): void;
  handleOpenGallery(itemIndex: number): () => void;
  medias: GalleryMedia[];
};

function GalleryView({ medias, handleClickGalleryIcon, handleOpenGallery }: Props) {
  return (
    <div className={styles.mediaGroupContainer}>
      <div className={styles.mainMediaWrapper}>
        <Media
          className={styles.zoomMedia}
          wrapperClassName={styles.mediaWrapper}
          key={`${medias[0].url}`}
          media={medias[0]}
          sizes="30vw"
          onClick={handleOpenGallery(0)}
        />
        <GalleryIcon
          iconSize={16}
          photosCount={medias.length}
          className={styles.galleryIcon}
          onClick={handleClickGalleryIcon}
        />
      </div>

      <Media
        className={styles.zoomMedia}
        wrapperClassName={cx(styles.mediaWrapper, styles.subMediaWrapper)}
        key={`${medias[1].url}`}
        media={medias[1]}
        sizes="15vw"
        onClick={handleOpenGallery(1)}
      />
      <Media
        className={styles.zoomMedia}
        wrapperClassName={cx(styles.mediaWrapper, styles.subMediaWrapper)}
        key={`${medias[2].url}`}
        media={medias[2]}
        sizes="15vw"
        onClick={handleOpenGallery(2)}
      />
    </div>
  );
}

export default GalleryView;
